<template>
    <v-row class="d-flex align-center justify-space-between">
        <v-col cols="12" md="4" class="d-flex align-center ">
            <v-checkbox
                v-model="localDelivered"
                label="Marfă livrată"
                @change="onDeliveredChange"
                density="compact"
                hide-details
            />
        </v-col>
        <v-col v-if="hasAdvanceInvoice" cols="12" md="4" sm="12" class="mt-3">
            <v-text-field
                label="Data încasare avans"
                type="date"
                v-model="localAdvanceInvoiceDate"
                @update:modelValue="onAdvanceInvoiceDateChange"
                variant="outlined"
                density="compact"
                hide-details
                clearable
            />
        </v-col>
    </v-row>
</template>

<script>
export default {
    name: "ContractExtraFields",
    props: {
        hasAdvanceInvoice: {
            type: Boolean,
            default: false,
        },
        advanceInvoiceDate: {
            type: String,
            default: "",
        },
        deliveredGoods: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            localDelivered: this.deliveredGoods ?? false,
            localAdvanceInvoiceDate:
                this.advanceInvoiceDate ||
                new Date().toISOString().slice(0, 10),
        };
    },
    methods: {
        /**
         * Emit noua valoare a livrării către părinte
         * @emits update-delivered-goods
         */
        onDeliveredChange() {
            this.$emit("update-delivered-goods", this.localDelivered);
        },
        onAdvanceInvoiceDateChange() {
            this.$emit(
                "update-advance-invoice-date",
                this.localAdvanceInvoiceDate
            );
        },
    },
};
</script>
